<div class="page">
    <div class="page-padding">
        <div class="page-header-custom">
            <svg-icon [svgStyle]="{'fill': '#0d2e5d'}" src="assets/svg/local-shipping.svg"></svg-icon>
            <h1 class="page-title">
                <strong>{{'dashboards.clipboard.title'|translate}}</strong>
            </h1>
        </div>

        <!-- BADGE crítico: dados ilustrativos, não confundir com dados reais. -->
        <div class="dashboard-mock-badge">
            <strong>{{'dashboards.mockWarning'|translate}}</strong>
        </div>

        <div class="page-filter">
            <div class="input-material">
                <input id="dashboard-date" class="form-control dashboard-daterangepicker" type="text" required/>
                <label for="dashboard-date">{{'dashboards.filters.period'|translate}}</label>
            </div>
            <div class="input-material select">
                <select name="country" id="country" (change)="getUnities()"
                        [(ngModel)]="selectedCountryId" class="form-control" required>
                    <option [ngValue]="undefined">{{'all'|translate}}</option>
                    <option *ngFor="let c of countries" value="{{c.id}}">{{c.name}}</option>
                </select>
                <label for="country">{{'dashboards.filters.country'|translate}}</label>
            </div>
            <div class="input-material select" style="min-width: 140px !important;">
                <select name="unity" id="unity" [(ngModel)]="filter.unityId" class="form-control" required>
                    <option [ngValue]="undefined">{{'all'|translate}}</option>
                    <option *ngFor="let c of unities" value="{{c.id}}">{{c.name}}</option>
                </select>
                <label for="unity">{{'dashboards.filters.unity'|translate}}</label>
            </div>
            <a (click)="applyFilter()" class="btn btn-primary btn-lg text-white">{{'dashboards.filters.search'|translate}}</a>
            <a href="javascript:void(0)" (click)="clearFilter()" class="btn btn-secondary btn-lg text-white" type="button">
                <span>{{'dashboards.filters.clear'|translate}}</span>
            </a>
        </div>

        <!-- Faixa de KPIs -->
        <section class="row kpi-row">
            <div class="col-6 col-md-4 col-xl-2 mb-3" *ngFor="let kpi of kpiCards">
                <app-kpi-card [label]="kpi.label" [value]="kpi.value" [hint]="kpi.hint"
                              [variant]="kpi.variant"></app-kpi-card>
            </div>
        </section>

        <!-- Gráficos: 1–4 em grid 2x2, 5 em largura total -->
        <section class="row">
            <article class="col-12 col-lg-6 mb-4">
                <div class="card-primary">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <p class="card-primary-header-title">
                                <strong>{{'dashboards.clipboard.charts.c1Title'|translate}}</strong></p>
                            <hr>
                        </div>
                        <div class="card-primary-body">
                            <div class="card-primary-body-graph">
                                <google-chart
                                        [type]="'LineChart'"
                                        [data]="myData1"
                                        [columns]="columnNames1"
                                        [options]="options1"
                                        style="width: 100%; height: 300px;">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <article class="col-12 col-lg-6 mb-4">
                <div class="card-primary">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <p class="card-primary-header-title">
                                <strong>{{'dashboards.clipboard.charts.c2Title'|translate}}</strong></p>
                            <hr>
                        </div>
                        <div class="card-primary-body">
                            <div class="card-primary-body-graph">
                                <google-chart
                                        [type]="'ColumnChart'"
                                        [data]="myData2"
                                        [columns]="columnNames2"
                                        [options]="options2"
                                        style="width: 100%; height: 300px;">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <article class="col-12 col-lg-6 mb-4">
                <div class="card-primary">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <p class="card-primary-header-title">
                                <strong>{{'dashboards.clipboard.charts.c3Title'|translate}}</strong></p>
                            <hr>
                        </div>
                        <div class="card-primary-body">
                            <div class="card-primary-body-graph">
                                <google-chart
                                        [type]="'BarChart'"
                                        [data]="myData3"
                                        [columns]="columnNames3"
                                        [options]="options3"
                                        style="width: 100%; height: 300px;">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <article class="col-12 col-lg-6 mb-4">
                <div class="card-primary">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <p class="card-primary-header-title">
                                <strong>{{'dashboards.clipboard.charts.c4Title'|translate}}</strong></p>
                            <hr>
                        </div>
                        <div class="card-primary-body">
                            <div class="card-primary-body-graph">
                                <google-chart
                                        [type]="'PieChart'"
                                        [data]="myData4"
                                        [columns]="columnNames4"
                                        [options]="options4"
                                        style="width: 100%; height: 300px;">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <article class="col-12 mb-4">
                <div class="card-primary">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <p class="card-primary-header-title">
                                <strong>{{'dashboards.clipboard.charts.c5Title'|translate}}</strong></p>
                            <hr>
                        </div>
                        <div class="card-primary-body">
                            <div class="card-primary-body-graph">
                                <google-chart
                                        [type]="'BarChart'"
                                        [data]="myData5"
                                        [columns]="columnNames5"
                                        [options]="options5"
                                        style="width: 100%; height: 240px;">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>
    </div>
</div>
